/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./BioMatrix.vue?vue&type=template&id=17a588dc&scoped=true"
import script from "./BioMatrix.vue?vue&type=script&lang=js"
export * from "./BioMatrix.vue?vue&type=script&lang=js"
import style1 from "./BioMatrix.vue?vue&type=style&index=1&id=17a588dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17a588dc",
  null
  
)

export default component.exports